import { Link } from "react-router-dom";

const BlogCard = ({ blog, type }) => {
  return (
    <div className={`blog-card ${type === "related" ? "blog-card-related" : ""}`}>
      <img src={blog.PictureUrl} alt={blog.Title} />

      <span className="badge">{blog.Category}</span>

      <div className="blog-details">
        <h3 className="blog-name"> {blog.Title.length > 35 ? blog.Title.slice(0, 35) + "..." : blog.Title}</h3>
        <p className="blog-dis">{blog.ShortDescription}</p>

        <Link to={`/blog/${blog.Id}`} className="read-more">
          LEARN MORE
        </Link>
        <span>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="rgba(38,58,131,1)">
            <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path>
          </svg>
        </span>
      </div>
    </div>
  );
};

export default BlogCard;
